import { fork, all } from 'redux-saga/effects';

import * as detailPrices from './detailPrices';

export default function* rootSaga() {
  yield all([...Object.values(detailPrices)].map(fork));
}
